import React from "react";
import gql from "graphql-tag";
import { get, isNil } from "lodash";
import { useQuery } from "@apollo/react-hooks";
import useFirebaseSession from "hooks/useFirebaseSession";

const storyQuery = gql`
  query storyQuery(
    $storySlug: String!
    $firebaseId: ID!
    $sharedStoryLinkId: ID
  ) {
    user(firebaseId: $firebaseId) {
      id
      subscriptionHasExpired
    }

    sharedStoryLinkExists(sharedStoryLinkId: $sharedStoryLinkId)

    story(storySlug: $storySlug, sharedStoryLinkId: $sharedStoryLinkId) {
      id
      slug
      title
      summary
      author {
        id
        fullName
        slug
      }
      authorMultiple {
        id
        fullName
        slug
      }
      categories {
        id
        name
      }
      publicationDate
      textEssay {
        id
        images {
          id
          url
          description
        }
        bodyHtml
      }
      relatedStories {
        id
        slug
        title
        publicationDate
        author {
          id
          fullName
          slug
        }
        authorMultiple {
          id
          fullName
          slug
        }
        summary
        featuredImage {
          id
          url
        }
      }
    }
  }
`;

function StoryQuery({ children, storySlug, sharedStoryLinkId }) {
  const { loggedInUserId } = useFirebaseSession();
  const variables = {
    storySlug,
    sharedStoryLinkId,
    firebaseId: loggedInUserId,
  };

  const { data, error } = useQuery(storyQuery, { variables });

  const loading = isNil(data);

  const result = {
    story: get(data, "story", {}),
    user: get(data, "user", {}),
    sharedStoryLinkExists: get(data, "sharedStoryLinkExists", false),
  };

  console.log(error);

  return loading || error ? <></> : children(result);
}

export default StoryQuery;
